// if ( objects.is_front_page ) {
//     gsap.set("#tommyco-presentation path", { drawSVG: 0 });
//     gsap.to("#tommyco-presentation path", {
//         drawSVG: true,   
//         fill: '#fff',
//         stagger: 0.2,
//         scrollTrigger: {
//             trigger: "#tommyco-presentation",
//             start: "top center", 
//             end: "bottom center", 
//             toggleActions: "play none none reverse"
//         }
//     });
// }